import InformationCircle from "./Svg/InformationCircle";
import Modal from "./Helpers/Modal";
import { Trans, useTranslation } from "react-i18next";
import { useState } from "react";

export default function UspBar() {
  const { t } = useTranslation();
  const [showExplainerModal, setShowExplainerModal] = useState<boolean>(false);

  return (
    <>
      <div className="flex justify-center bg-custom-500 text-white text-fluid-sm">
        <div className="flex items-center">
          <p>{t("component.uspBar.title")}</p>
          <div
            className="px-2 py-1"
            onClick={() => setShowExplainerModal(!showExplainerModal)}
          >
            <InformationCircle className="size-fluid-3 cursor-pointer" />
          </div>
        </div>
      </div>

      <Modal
        onClick={setShowExplainerModal}
        show={showExplainerModal}
        title={t("modal.uspBar.title")}
      >
        <Trans i18nKey="modal.uspBar.content" components={{ br: <br /> }} />
      </Modal>
    </>
  );
}
